import { withRequestId } from 'src/modules/seek-api-request';

export const buildApiHeaders = (requestId?: string) => ({
  ...withRequestId(requestId),
});
